import { PlusIcon, ProductsIcon } from "@xola/icons";
import { Alert, Button } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Package } from "types";
import { Loader } from "../../Loader";
import { PartnerPackageTile } from "./PartnerPackageTile";

interface PackageListProps {
    packages: Package[];
    isLoading: boolean;
    isFiltered: boolean;
}

export const PartnerPackageList = ({ packages = [], isLoading, isFiltered }: PackageListProps) => {
    if (isLoading) {
        return <Loader size="tiny" className="p-2" text="Loading Partner Packages" />;
    }

    return (
        <div className="py-15 px-10">
            {packages.length > 0 || isFiltered ? (
                <div className="grid grid-cols-2 gap-y-10 gap-x-12">
                    {packages.map((partnerPackage: Package) => (
                        <PartnerPackageTile key={partnerPackage.id} partnerPackage={partnerPackage} />
                    ))}
                </div>
            ) : (
                <NoPartnerPackagesAlert />
            )}
        </div>
    );
};

export const NoPartnerPackagesAlert = () => {
    const history = useHistory();

    const handleCreateProductClick = () => {
        history.push("/products/partnerPackages/new");
    };

    return (
        <div className="max-w-xl">
            <Alert color="primary">
                <div className="flex p-2">
                    <ProductsIcon size="large" />

                    <div className="ml-2" data-testid="no-product-alert">
                        <div className="mb-3 flex space-x-2">
                            <span className="text-md font-bold">No Partner Packages Found</span>
                        </div>

                        <span className="text-base">
                            You do not have any partner packages yet. Please create your first partner package to get
                            started.
                        </span>

                        <div className="mt-2 flex justify-end">
                            <Button size="small" color="primary" icon={<PlusIcon />} onClick={handleCreateProductClick}>
                                Create Partner Package
                            </Button>
                        </div>
                    </div>
                </div>
            </Alert>
        </div>
    );
};
